import { tuApptoAPI, getAuthHeaders, getErrorData } from './config'

const headers = getAuthHeaders().headers
export const findAll = async id => {
  try {
    const response = await tuApptoAPI.get(`/maintenances/${id}`, { headers })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const disabled = async request => {
  try {
    const response = await tuApptoAPI.post('/maintenances/disabled', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const available = async request => {
  try {
    const response = await tuApptoAPI.post('/maintenances/available', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const create = async request => {
  try {
    const response = await tuApptoAPI.post('/maintenances/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const status = async request => {
  try {
    const response = await tuApptoAPI.post('/maintenances/status', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const update = async request => {
  // const headers = {
  //   'x-token': sessionStorage.getItem('token')
  // }
  // try {
  //   const response = await tuApptoAPI.put(`/maintenances/${request.id}`, request, { headers })
  //   return response.data
  // } catch (error) {
  //   return error.response.data
  // }
  return { ok: true, message: 'OK' }
}
